const num = (v) => parseInt(v) || 0

export const grantedCount = (q) => Math.max(0, Math.max(num(q.GrantBase), ...q.Grants.map(num)) + num(q.GrantInc))

const recount = (q) => {
    q.Count = String(grantedCount(q))
    return q
}

export const shiftGranted = (q, delta) => {
    let base = num(q.GrantBase)
    let inc = num(q.GrantInc)
    if (delta < 0) {
        const fromInc = Math.min(Math.max(inc, 0), -delta)
        inc -= fromInc
        delta += fromInc
        const fromBase = Math.min(Math.max(base, 0), -delta)
        base -= fromBase
        delta += fromBase
    }
    q.GrantBase = base
    q.GrantInc = inc + delta
    return recount(q)
}

export const addGrant = (q, count) => {
    if (!q.Grants) {
        q.GrantBase = num(q.Count)
        q.GrantInc = 0
        q.Grants = []
    }
    q.Grants.push(num(count))
    return recount(q)
}

export const removeGrant = (q, count) => {
    const i = q.Grants.indexOf(num(count))
    q.Grants.splice(i === -1 ? q.Grants.length - 1 : i, 1)
    if (q.Grants.length) {
        recount(q)
        return null
    }
    const total = num(q.GrantBase) + num(q.GrantInc)
    delete q.Grants
    delete q.GrantBase
    delete q.GrantInc
    return total
}

export const qualityModeOf = (mod) => mod.QualReplace ? "replace" : mod.QualSet ? "grant" : mod.NewCount ? "new" : "add"
